/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC } from "react";
import OptionList from "../OptionList";
import FunctionAssignerButtons from "../../atoms/FunctionAssignerButtons";
import * as CSS from "./styles";
import { OptionListData } from "./types";
import { SaveButtonWithLabel } from "../../atoms/inputs/EwaButtons";
import { withLoaderHOC, WithLoaderHOC } from "../../atoms/Loader";
import { useFormatMsg } from "../../../hooks/useFormatMsg";

const X2yForm: FC<Props> = ({
  leftList,
  rightList,
  multiList,
  moveLeft,
  moveRight,
  noSaveButton = false,
  onSave,
  isFetching = false,
  isSubmitting = false,
  placeholder,
}) => {
  const formatMsg = useFormatMsg();
  const isButtonDisabled = isFetching || isSubmitting;
  const isLoading =
    isFetching &&
    leftList.options.length === 0 &&
    rightList.options.length === 0;

  // Zasekne se o minSize a maxSize defaulty
  const totalOptionCnt = rightList.options.length + leftList.options.length;
  const listLength = Math.max(totalOptionCnt, multiList?.options?.length ?? 0);

  return (
    <div css={CSS.containerCss}>
      <div css={CSS.listsContainerCss}>
        {multiList && (
          <div
            css={[CSS.columnCss, CSS.forGroupColumnCss]}
            data-cy="select-module"
          >
            <div css={CSS.columnHeaderCss}>{multiList.header || "\u00A0"}</div>
            <div css={CSS.optionListContainerCss}>
              <OptionList
                {...multiList}
                size={listLength}
                isLoading={isLoading}
              />
            </div>
          </div>
        )}

        <div css={CSS.columnCss} data-cy="unselected-templates">
          <div css={CSS.columnHeaderCss}>{leftList.header || "\u00A0"}</div>
          <div css={CSS.optionListContainerCss}>
            <OptionList
              {...leftList}
              size={listLength}
              isLoading={isLoading}
              placeholder={placeholder}
            />
          </div>
        </div>

        <div css={CSS.columnCss}>
          <div css={CSS.columnHeaderCss} />
          <div css={CSS.arrowsContainerCss}>
            <FunctionAssignerButtons
              selectFocused={moveRight}
              unselectFocused={moveLeft}
            />
          </div>
        </div>

        <div css={CSS.columnCss} data-cy="selected-templates">
          <div css={CSS.columnHeaderCss}>{rightList.header || "\u00A0"}</div>
          <div css={CSS.optionListContainerCss}>
            <OptionList
              {...rightList}
              size={listLength}
              isLoading={isLoading}
              placeholder={placeholder}
            />
          </div>
        </div>
      </div>

      {totalOptionCnt === 0 && (
        <div css={CSS.noOptionsFoundCss}>{formatMsg("x2y.no_items_found")}</div>
      )}
      {!noSaveButton && (
        <div css={CSS.buttonContainerCss}>
          <SaveButtonWithLabel
            onClick={onSave}
            disabled={isButtonDisabled}
            isLoading={isButtonDisabled}
            autoFocus
            data-cy="save-button"
          />
        </div>
      )}
    </div>
  );
};

export type Props = {
  leftList: OptionListData;
  rightList: OptionListData;
  multiList?: OptionListData;

  moveLeft: () => void;
  moveRight: () => void;

  noSaveButton?: boolean;
  onSave?: () => void;

  isFetching?: boolean;
  isSubmitting?: boolean;

  placeholder?: string;
};

export default withLoaderHOC(X2yForm);
export type ControlledProps = WithLoaderHOC<Props>;
